import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import Button from '../../components/button/Button';
import { cardsBrand } from '../../components/card/constants';
import Icon from '../../components/icon/Icon';
import List from '../../components/list/List';
import Loading from '../../components/loading/Loading';
import { getJobReceipt, getMembershipReceipt, getUserProfile, showModal } from '../../redux/actions';
import T from 'prop-types';
import { useSearchParam } from 'react-use';
import { PROJECT_TRIAL_MEMBERS_MODAL } from '../../components/modal/ProjectTrialMembers/ProjectTrialMembers';
import TextDivider from '../../components/text/TextDivider';
import useCurrentProject from '../../hooks/useCurrentProject';
import routes from '../../routes/constants';
import text, { formatCurrency } from '../../text';
import { formatDate } from '../../utilities/date';
import { isEmpty } from 'lodash';
export var ReceiptItem = function(param) {
    var receipt = param.receipt, description = param.description;
    var _receipt_value, _receipt_value1, _receipt_value2, _receipt_value3, _receipt_value4;
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("tbody", {
        className: "ReceiptItem"
    }, /*#__PURE__*/ React.createElement(List.Item, {
        description: /*#__PURE__*/ React.createElement("h3", null, description),
        value: /*#__PURE__*/ React.createElement("h3", null, formatCurrency((_receipt_value = receipt.value) === null || _receipt_value === void 0 ? void 0 : _receipt_value.amount, (_receipt_value1 = receipt.value) === null || _receipt_value1 === void 0 ? void 0 : _receipt_value1.currency.name, (_receipt_value2 = receipt.value) === null || _receipt_value2 === void 0 ? void 0 : _receipt_value2.currency.scale_factor, {}, true))
    })), /*#__PURE__*/ React.createElement(Link, {
        to: {
            pathname: (_receipt_value3 = receipt.value) === null || _receipt_value3 === void 0 ? void 0 : _receipt_value3.receipt_url
        },
        className: "mb-3",
        href: "#",
        target: "_blank"
    }, text('viewReceipt', {
        receiptNumber: (_receipt_value4 = receipt.value) === null || _receipt_value4 === void 0 ? void 0 : _receipt_value4.receipt_number
    })));
};
ReceiptItem.propTypes = {
    receipt: T.object,
    description: T.object
};
var PaymentSuccess = function(props) {
    var _orderReceipt_value, _orderReceipt_value1;
    var isTrial = useSearchParam('isTrial');
    var jobId = props.jobId, orderPaymentIntent = props.orderPaymentIntent, membershipPaymentIntent = props.membershipPaymentIntent;
    var dispatch = useDispatch();
    useCurrentProject({
        enableJob: true
    });
    var _useSelector = useSelector(function(state) {
        return {
            orderReceipt: state.jobsReducer.receipt,
            membershipReceipt: state.profileReducer.membershipReceipt,
            currentProject: state.project.currentProject
        };
    }), currentProject = _useSelector.currentProject, orderReceipt = _useSelector.orderReceipt, membershipReceipt = _useSelector.membershipReceipt;
    useEffect(function() {
        var _orderPaymentIntent_value;
        if ((orderPaymentIntent === null || orderPaymentIntent === void 0 ? void 0 : (_orderPaymentIntent_value = orderPaymentIntent.value) === null || _orderPaymentIntent_value === void 0 ? void 0 : _orderPaymentIntent_value.id) || currentProject) {
            dispatch(getJobReceipt(jobId, orderPaymentIntent === null || orderPaymentIntent === void 0 ? void 0 : orderPaymentIntent.value.id));
        }
    }, [
        currentProject,
        dispatch,
        jobId,
        orderPaymentIntent
    ]);
    useEffect(function() {
        dispatch(getUserProfile());
    }, [
        dispatch
    ]);
    useEffect(function() {
        var _membershipPaymentIntent_value;
        if ((membershipPaymentIntent === null || membershipPaymentIntent === void 0 ? void 0 : (_membershipPaymentIntent_value = membershipPaymentIntent.value) === null || _membershipPaymentIntent_value === void 0 ? void 0 : _membershipPaymentIntent_value.id) || isTrial === 'true') {
            var _membershipPaymentIntent_value1;
            // fetch subscription details if user is upgrading from trial since paymentIntent does not exist on Stripes subscription.update
            dispatch(getMembershipReceipt(jobId, membershipPaymentIntent === null || membershipPaymentIntent === void 0 ? void 0 : (_membershipPaymentIntent_value1 = membershipPaymentIntent.value) === null || _membershipPaymentIntent_value1 === void 0 ? void 0 : _membershipPaymentIntent_value1.id));
        }
    }, [
        dispatch,
        isTrial,
        jobId,
        membershipPaymentIntent
    ]);
    return /*#__PURE__*/ React.createElement("div", {
        className: "PaymentSuccess"
    }, !orderReceipt.isLoading || !membershipReceipt.isLoading ? /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Icon, {
        icon: "circled-tick_filled"
    }), /*#__PURE__*/ React.createElement("div", {
        className: "w-100"
    }, /*#__PURE__*/ React.createElement("h3", {
        className: "text-center"
    }, text('thanksForPayment')), /*#__PURE__*/ React.createElement(TextDivider, {
        isComplete: true,
        isSecondary: true
    })), /*#__PURE__*/ React.createElement(List, null, orderPaymentIntent && orderReceipt ? /*#__PURE__*/ React.createElement(ReceiptItem, {
        receipt: orderReceipt,
        description: text('survey')
    }) : null, (membershipPaymentIntent.value || isTrial === 'true') && !isEmpty(membershipReceipt) ? /*#__PURE__*/ React.createElement(ReceiptItem, {
        receipt: membershipReceipt,
        description: text('membership')
    }) : null), /*#__PURE__*/ React.createElement("div", null, text('receiptEmailSent')), /*#__PURE__*/ React.createElement(TextDivider, {
        isComplete: true,
        isSecondary: true
    }), /*#__PURE__*/ React.createElement("div", {
        className: "full-width"
    }, /*#__PURE__*/ React.createElement(List, {
        isPaddingless: true
    }, /*#__PURE__*/ React.createElement(List.Item, {
        description: text('paymentDate'),
        value: orderReceipt.value ? formatDate((_orderReceipt_value = orderReceipt.value) === null || _orderReceipt_value === void 0 ? void 0 : _orderReceipt_value.payment_date) : null
    }), /*#__PURE__*/ React.createElement(List.Item, {
        description: text('paymentMethod'),
        value: cardsBrand[(_orderReceipt_value1 = orderReceipt.value) === null || _orderReceipt_value1 === void 0 ? void 0 : _orderReceipt_value1.card.brand]
    }))), /*#__PURE__*/ React.createElement(TextDivider, {
        isComplete: true,
        isSecondary: true
    }), /*#__PURE__*/ React.createElement("p", null, text('sharePlatformWithTeam')), /*#__PURE__*/ React.createElement(Button, {
        autoFocus: true,
        className: "full-width",
        onClick: function() {
            return dispatch(showModal(PROJECT_TRIAL_MEMBERS_MODAL, {
                projectId: currentProject.id
            }));
        }
    }, text('proceedToShare')), /*#__PURE__*/ React.createElement("a", {
        className: "mt-3",
        name: "cancel",
        href: routes.dashboard
    }, text('goToDashboard'))) : /*#__PURE__*/ React.createElement(Loading, null));
};
PaymentSuccess.propTypes = {
    jobId: T.number,
    orderPaymentIntent: T.object,
    membershipPaymentIntent: T.object
};
export default PaymentSuccess;
